// src/components/SectionHeader.jsx
import React, { useState } from 'react';
import { ReactComponent as Underline } from '../../../icons/underline design.svg';

const SectionHeader = ({
  title = '',
  className = '',
}) => {


  return (
    <div className={`bg-primary-shade1 border-t border-b border-[#FF7236] py-8 ${className}`}>
      <h2 className="text-3xl font-medium text-center text-[#171D1B]">
        {title}
      </h2>
      <div className="flex justify-center mt-2">
        <Underline className="h-4" />
      </div>
    </div>
  );
};

export default SectionHeader;
